import { renderRichText } from '../../../core/utils/render-rich-text.util';
import { resolveStrapiMediaUrl } from '../../../core/utils/strapi-media.util';

export function adaptCalloutBlock(
  entry: Record<string, unknown>,
  baseUrl: string,
): Record<string, unknown> {
  const image = entry['imageSrc'] as Record<string, unknown> | null;
  const imageUrl = (image?.['url'] as string) ?? '';

  return {
    color: (entry['color'] as string) ?? 'orange',
    heading: renderRichText((entry['heading'] as string) ?? ''),
    body: renderRichText((entry['body'] as string) ?? ''),
    imageSrc: resolveStrapiMediaUrl(baseUrl, imageUrl) ?? '',
    imageAlt: (image?.['alternativeText'] as string) ?? '',
    imageWidth: (image?.['width'] as number) ?? 0,
    imageHeight: (image?.['height'] as number) ?? 0,
  };
}
